import { render, staticRenderFns } from "./VpsUpgradePlan.vue?vue&type=template&id=92631bb8&"
import script from "./VpsUpgradePlan.vue?vue&type=script&lang=js&"
export * from "./VpsUpgradePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports